import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthStateService } from '../core/services/auth-state/auth-state-service.service';

@Injectable({ providedIn: 'root' })
export class RoleAccountGuard implements CanActivate {
  constructor(
    private authStateService: AuthStateService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {

    const role = this.authStateService.getRole(); // <-- debe devolverte el logueado (desde token, storage, etc.)
    const account_type = this.authStateService.getAccountType(); // <-- debe devolverte el tipo de cuenta del usuario logueado
    const allowedRoles = route.data['role'] as string[] | undefined;
    const allowedAccountTypes = route.data['account_type'] as string[] | undefined;

    const roleMatch =  allowedRoles?.includes(role || ''); // Incluye Admin como rol permitido por defecto
    const typeMatch =  allowedAccountTypes?.includes(account_type || ''); // Incluye broker como tipo de cuenta permitido por defecto

    // Restricción por account_name para brokers (ej: solo idoneo.com ve C. Digitales)
    const brokerAccounts = route.data['broker_accounts'] as string[] | undefined;
    if (roleMatch && typeMatch && brokerAccounts && account_type === 'broker') {
      const accountName = this.authStateService.getAccountName();
      if (!brokerAccounts.includes(accountName || '')) {
        const redirectUrl = this.authStateService.getRedirectUrl();
        const currentPath = `/${route.routeConfig?.path ?? ''}`;
        return this.router.parseUrl(redirectUrl && redirectUrl !== currentPath ? redirectUrl : '/not-found');
      }
    }

    if (roleMatch && typeMatch) {
      return true;
    }

    // El rol no tiene acceso: lo mandamos a su pantalla inicial en lugar de a
    // /not-found, que antes caía en el wildcard '**' -> /orders y volvia a pasar
    // por este guard, generando un bucle infinito de redirecciones.
    const redirectUrl = this.authStateService.getRedirectUrl();
    const currentPath = `/${route.routeConfig?.path ?? ''}`;
    const targetUrl = redirectUrl && redirectUrl !== currentPath
      ? redirectUrl
      : '/not-found';

    return this.router.parseUrl(targetUrl);
  }
}
